import { useApi } from '~/api'
import { defineService } from '~/api/models/helpers'
import type { AuthArgs } from '~/api/models/index'
import type { CreateSitePayload, UpdateSitePayload } from '~/types/locations'

const queries = {
  getAllSites: {
    queryFn: () => useApi().locations.getSites(),
    queryKey: () => ['allSites']
  },
  getSiteById: {
    queryFn: (siteId: number) => useApi().locations.getSiteById(siteId),
    queryKey: (siteId: number) => ['site', String(siteId)]
  },
  getZonesBySiteId: {
    queryFn: (siteId: number) => useApi().locations.getSiteZones(siteId),
    queryKey: (siteId: number) => ['zonesBySiteId', String(siteId)]
  }
} as const

const mutations = {
  create: {
    request: (payload: CreateSitePayload) => useApi().locations.createSite(payload),
    cacheKey: () => ['allSites']
  },
  update: {
    request: ({ id, ...payload }: UpdateSitePayload) => useApi().locations.updateSite(id, payload),
    cacheKey: () => ['allSites']
  },
  delete: {
    request: (id: number) => useApi().locations.deleteSite(id),
    cacheKey: () => ['allSites']
  }
} as const

export type LocationService = ReturnType<typeof defineService<typeof queries, typeof mutations>>

export const registerService = (authArgs: AuthArgs): LocationService =>
  defineService(authArgs, {
    queries,
    mutations
  })
